export const ASYNC_STATES = [
  'LOADING', 'SUCCESS', 'EMPTY', 'PARTIAL', 'DELAYED', 'INSUFFICIENT_DATA', 'UNAVAILABLE', 'FORBIDDEN', 'ERROR',
];

export const STATE_COPY = {
  LOADING: '불러오는 중', SUCCESS: '정상', EMPTY: '표시할 항목 없음', PARTIAL: '일부 정보만 사용 가능',
  DELAYED: '정보 갱신 지연', INSUFFICIENT_DATA: '판단에 필요한 정보 부족', UNAVAILABLE: '현재 사용할 수 없음',
  FORBIDDEN: '접근 권한 없음', ERROR: '오류가 발생했습니다',
};
